export function getFormBuilderId(name: string) {
  return `form-builder-${name}`;
}
